import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	escalationPolicyAdded: {
		id: 'eoc.escalation-policy.flag.escalation-policy-added.no-translate',
		defaultMessage: `Escalation policy "{name}" added.`,
		description:
			'Title of success message that will be displayed in the flag after escalation policy created',
	},
	escalationPolicySaved: {
		id: 'eoc.escalation-policy.flag.escalation-policy-updated.no-translate',
		defaultMessage: `Escalation policy "{name}" saved.`,
		description:
			'Title of success message that will be displayed in the flag after escalation policy updated',
	},
	escalationPolicyDeleted: {
		id: 'eoc.escalation-policy.flag.escalation-policy-deleted.no-translate',
		defaultMessage: `Escalation policy "{name}" deleted.`,
		description:
			'Title of success message that will be displayed in the flag after escalation policy deleted',
	},
	changeStateError: {
		id: 'eoc.escalation-policy.flag.change-state-error.no-translate',
		defaultMessage: `We couldn't {isEnabled, select,
      true {turn on}
      other {turn off}
    } the escalation policy.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while changing escalation policy state',
	},
	deleteError: {
		id: 'eoc.escalation-policy.flag.delete-error.no-translate',
		defaultMessage: `We couldn't delete the escalation policy.`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while deleting escalation policy',
	},
	createError: {
		id: 'eoc.escalation-policy.flag.create-error.no-translate',
		defaultMessage: `We couldn't create the escalation policy`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while creating the escalation policy',
	},
	updateError: {
		id: 'eoc.escalation-policy.flag.update-error.no-translate',
		defaultMessage: `We couldn't update the escalation policy`,
		description:
			'Title of error message that will be displayed in the flag if something went wrong while updating the escalation policy',
	},
});

export default messages;
